import React from 'react';
import PropTypes from 'prop-types';
import CopyCatSearch from '../components/CopyCatSearch';

function CopycatRoute(props) {
  return <CopyCatSearch {...props} />;
}

CopycatRoute.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.object,
};

export default CopycatRoute;
